import { useState } from 'react'
import CopySvg from '../assets/img/svg/copy'
import DownSvg from '../assets/img/svg/down'

const GridPowerBI = ({ data }) => {
  const [open, setOpen] = useState([])

  console.log(open)

  return (
    <div className="grid-powerbi">
      {data &&
        data.map((e) => {
          return (
            <div className="grid-powerbi-item" key={e.id}>
              <div className="grid-powerbi-flex">
                <div className="grid-powerbi-item-link">
                  <CopySvg
                    className="grid-close"
                    onClick={() => navigator.clipboard.writeText(e.link)}
                  />
                  <span>{e.link}</span>
                </div>
                <DownSvg
                  className={`grid-powerbi-item-down${
                    open.includes(e.id) ? '-active' : ''
                  }`}
                  onClick={() =>
                    open.includes(e.id)
                      ? setOpen(open.filter((f) => f !== e.id))
                      : setOpen([...open, e.id])
                  }
                />
              </div>
              <div
                style={open.includes(e.id) ? {} : { display: 'none' }}
                className="grid-powerbi-grid"
              >
                <div dangerouslySetInnerHTML={{ __html: e.desc }} />
                <div dangerouslySetInnerHTML={{ __html: e.resp }} />
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default GridPowerBI
